import { ReactNode } from "react";
import { ToastOptions, toast } from "react-toastify";

export const triggerToast = ({
  content,
  toastId,
}: {
  content: ReactNode;
  toastId?: ToastOptions["toastId"];
}) => {
  if (toastId && toast.isActive(toastId)) {
    toast.update(toastId, { render: content });
    return;
  }

  toast.info(content, {
    toastId,
    position: "bottom-left",
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
};
